import React, {useState} from 'react';
import {RESOURCES} from "@shared/Resources/types";
import {
    SkillsListItem
} from "@containers/Admin/containers/UserPage/user-page-wrapper/components/UserPersonalProgram/components/SkillsListItem";
import {useTranslation} from "react-i18next";
import {
    SkillsListHeader
} from "@containers/Admin/containers/UserPage/user-page-wrapper/components/UserPersonalProgram/components/SkillsListHeader";
import {Box} from "@mui/material";
import Text from "@components/Text/index.js";
import {useCustomSelector} from "src/hooks/useCustomSelector";
import {
    SkillsListWrapper
} from "@containers/Admin/containers/UserPage/user-page-wrapper/components/UserPersonalProgram/components/SkillsList/styles";
import { Skill } from '@app-types/skill.types';

export const SkillsList = () => {
    const {overview: {resource}} = useCustomSelector('resourceManager')
    const {t} = useTranslation()
    const [isExpanded, setIsExpanded] = useState(false)
    const currentSkillIndex = resource?.Skills?.findIndex(
        (item: Skill) => item.id === resource?.nextCourseActivity?.skillId,
    ) ?? -1;

    const onSkillsListToggle = () => setIsExpanded((prev) => !prev)

    return (
        <SkillsListWrapper>
            <SkillsListHeader isExpanded={isExpanded} onSkillsListToggle={onSkillsListToggle}/>
            {
                !!resource?.Skills?.length
                    ? resource?.Skills?.map((item: Skill, index: number) => (
                        <div key={item.name} className={RESOURCES.SKILL}>
                            <SkillsListItem
                                item={item}
                                isExpandedAll={isExpanded}
                                isBeforeCurrentSkill={currentSkillIndex >= 0 && index < currentSkillIndex}
                            />
                        </div>
                    ))
                    : <Box mt={2}>
                        <Text>{t('Errors.dataMissing')}</Text>
                    </Box>
            }
        </SkillsListWrapper>
    );
};